import React from 'react';

import translations from 'services/translations/translations';
import sortByTranslation from 'services/sort/sortByTranslation';
import {
  ICategoryChoices,
  MATERIAL_CATEGORY,
  getChoiceList,
} from 'services/offers/offerChoices';

const ProductCategoryOptions = (
  categories: string[],
  t: any,
  // The choice list of the admins: their names and order, without the hidden ones except
  // the current category of the row
  categoryChoices?: ICategoryChoices & { current?: null | string }
): JSX.Element[] => {
  const categoriesTranslationLocation = `${translations.products}:categories`;
  const emptyOption = (
    <option key="product-category-empty" value="">
      -
    </option>
  );

  if (
    categoryChoices !== undefined &&
    categoryChoices.choices.some((choice) => choice.list === MATERIAL_CATEGORY)
  ) {
    return [
      emptyOption,
      ...getChoiceList(
        categoryChoices.choices,
        MATERIAL_CATEGORY,
        categoryChoices.current,
        categoryChoices.language
      ).map((option) => (
        <option key={`product-category-${option.value}`} value={option.value}>
          {option.label}
        </option>
      )),
    ];
  }

  const getOption = (category: null | string) => {
    if (category === null) {
      return emptyOption;
    }

    return (
      <option key={`product-category-${category}`} value={category}>
        {t(`${categoriesTranslationLocation}:${category}`, {
          defaultValue: category,
        })}
      </option>
    );
  };

  const categoriesSortedByTranslation = [...categories].sort(
    sortByTranslation(t, categoriesTranslationLocation)
  );

  const categoriesWithEmptyOption = [null, ...categoriesSortedByTranslation];

  return categoriesWithEmptyOption.map((category: null | string) =>
    getOption(category)
  );
};

export default ProductCategoryOptions;
